import { render } from "./Photopage.vue?vue&type=template&id=4d8463c8&scoped=true&ts=true"
import script from "./Photopage.vue?vue&type=script&lang=ts"
export * from "./Photopage.vue?vue&type=script&lang=ts"

import "./Photopage.vue?vue&type=style&index=0&id=4d8463c8&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/democratielab-poster/democratielab-poster/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d8463c8"]])

export default __exports__